module.exports = __webpack_public_path__ + "static/media/icon5.db31cafa.png";